import { render, staticRenderFns } from "./patients-prepay-form.vue?vue&type=template&id=7ebbea31"
import script from "./patients-prepay-form.vue?vue&type=script&lang=js"
export * from "./patients-prepay-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports